window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      return
    }

    const marketingAllowed = window.Shopify.customerPrivacy.currentVisitorConsent().marketing

    if (marketingAllowed === 'yes') {
      siteTrackingScript()
    }
  }
)

document.addEventListener('visitorConsentCollected', (event) => {
  const marketingAllowed = event.detail.marketingAllowed
  if (marketingAllowed === true) {
    siteTrackingScript()
  }
})

function siteTrackingScript () {
  const script = document.createElement('script')
  script.setAttribute('src', 'https://r1-t.trackedlink.net/_dmpt.js')
  script.setAttribute('type', 'text/javascript')
  script.defer = true
  document.head.appendChild(script)
}
